import React from "react";

// Colorful wordmark matching the playful logo colors
const COLORS = ["#ef4444", "#fbbf24", "#22c55e", "#3b82f6", "#ec4899"];

const ColorfulBrand = ({ className = "" }) => {
  const word1 = "Casagrande";
  const word2 = "Brinquedos";

  const renderWord = (word, offset = 0) =>
    word.split("").map((ch, i) => (
      <span key={`${offset}-${i}`} style={{ color: COLORS[(i + offset) % COLORS.length] }}>
        {ch}
      </span>
    ));

  return (
    <span
      className={`font-display font-bold tracking-tight whitespace-nowrap ${className}`}
    >
      {renderWord(word1, 0)}
      <span>&nbsp;</span>
      {renderWord(word2, 3)}
    </span>
  );
};

export default ColorfulBrand;
